// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oOSNY","top":"styles_top__6LHy9"};